// NEW STYPEPARAMS METHOD
var LOAD_MORE_AMOUNT = {
    PARTIAL: 'PARTIAL',
    ALL: 'ALL',
};
export default LOAD_MORE_AMOUNT;
//# sourceMappingURL=behaviourParams_gallery_vertical_loadMore_amount.js.map